import { SpaceBetween, spacing, styled, TextElement } from '@lessonup/ui-components';
import React from 'react';
import { useEffectivePinComponentSettings } from '../../../../../utils/pinTheme/PinThemeContext';

export interface SortingQuestionAnswerAreaContentWrapperProps {
  showScrollbar?: boolean;
  description?: string;
  children: React.ReactNode;
}

export const SortingQuestionAnswerAreaWrapper: React.FC<SortingQuestionAnswerAreaContentWrapperProps> = ({
  showScrollbar = false,
  description,
  children,
}) => {
  // Using the same colors as the text pin component so it doesn't become unreadable
  const { fontColor } = useEffectivePinComponentSettings('TEXT', {
    settings: {},
  });
  return (
    <Wrapper
      style={{
        overflowY: showScrollbar ? 'auto' : 'hidden',
      }}
    >
      {description && (
        <Description textStyle="bodyText" color={fontColor}>
          {description}
        </Description>
      )}
      <AnswerList direction="y" spacing={spacing.size8}>
        {children}
      </AnswerList>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: ${spacing.size16};
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacing.size16};
  position: relative;
`;

const AnswerList = styled(SpaceBetween)`
  margin-top: auto;
`;

const Description = styled(TextElement)`
  text-align: center;
  user-select: none;
  position: relative;
`;
